import React, { useState } from "react";
import { Styles } from "../award-event/styles/awardEvent";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import "./styles/event-common.css";

const Event12 = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper event-page">
        {/* Header 2 */}
        <Header />

        {/* Breadcroumb */}
        <BreadcrumbBox title="Event" img="16_5.jpeg" />
        <Container>
          <Row>
            <Col>
              <a
                href="/news"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  lineHeight: "40px",
                }}
              >
                Back To News
              </a>
            </Col>
          </Row>
        </Container>

        {/* News Area */}
        <section className="award-page">
          <Container>
            <Row>
              <Col md="12">
                <div style={{ padding: "20px 0" }}>
                  <h2
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    কল্পনার শহর | CWIS mini-series | EP 2 | RESOURCE PLANNING & MANAGEMENT
                  </h2>

                  

                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                   শহরে পরিবর্তন আনার জন্য দরকার সঠিক পরিকল্পনা এবং সম্পদের সুচিন্তিত ব্যবহার। টেকসই উন্নয়ন আসে তখনই, যখন পরিকল্পনা হয় বিচক্ষণভাবে, সম্পদ ব্যবহৃত হয় সঠিকভাবে, আর সবাই কাজ করে একসাথে। দেখুন CWIS এনিমেটেড সিরিজের দ্বিতীয় পর্ব – সম্পদ পরিকল্পনা ও ব্যবস্থাপনা, যেখানে দেখা যাবে শহরব্যাপী অন্তর্ভুক্তিমূলক স্যানিটেশন (বা সিটিওয়াইড ইনক্লুসিভ স্যানিটেশন/ CWIS) কীভাবে শহরে পরিবর্তন নিয়ে আসতে পারে Transforming cities calls for thoughtful planning and efficient resource management. Sustainable development is only possible when planning is strategic, resources are managed responsibly, and everyone works in collaboration. Watch the second episode of the CWIS animated series ‘Resource Planning and Management’ to see how Citywide Inclusive Sanitation (CWIS) can help build cleaner, more resilient cities.
                   <br /><br />
                   Video Link: <a
                      href="https://youtu.be/OZxl-sA7EHk?si=TxG3Yi312opa5p_O"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://youtu.be/OZxl-sA7EHk?si=TxG3Yi312opa5p_O
                    </a>
                  </p>
                  
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </Styles>
  );
};

export default Event12;
